import {ElementRef, Renderer2} from '@angular/core';

export function backgroundByUrl(url: string, renderer: Renderer2, el: ElementRef): void {
    const img: HTMLElement = renderer.createElement('div');
    renderer.setStyle(img, 'background', `url(${url})`);
    renderer.setStyle(img, 'background-size', 'cover');
    renderer.setStyle(img, 'background-position', 'center');
    renderer.setStyle(img, 'position', 'absolute');
    renderer.setStyle(img, 'inset', 0);
    renderer.appendChild(el.nativeElement, img);
    renderer.setStyle(el.nativeElement, 'position', 'relative');
    renderer.setStyle(el.nativeElement, 'overflow', 'hidden');
}
